<div *ngFor="let emailWrapper of emailArray; let index = index">
  <div class="row">
    <div class="form-group col pt-1 pb-1">
      <conn-email-input
        (modelChanged)="setEmailBuilderValue(index, $event)"
        [inputModel]="emailWrapper.inputText"
        [required]="true"
        [submitted]="submitted"
      >
      </conn-email-input>
    </div>
    <div class="col-1 buttonPadding">
      <i
        (click)="removeEmail(index)"
        *ngIf="index !== 0 || emailArray.length > 1"
        class="trashBtn fa fa-trash fa-lg"
        id="removeEmailButton"
      ></i>
    </div>
  </div>
  <div *ngIf="index + 1 === emailArray.length" class="col-12">
    <div class="row">
      <div class="col-12 text-start">
        <div
          (click)="addEmail()"
          class="btn btn-link btn-link-font-size"
          id="addEmailButton"
        >
          + Add more
        </div>
      </div>
    </div>
  </div>
</div>
